export function getErrorCode(response): any {
    return (response.responseJSON
            && response.responseJSON.Errors
            && response.responseJSON.Errors.General[0]
            && response.responseJSON.Errors.General[0].ErrorCode
           ) || (response
                 && response.Warnings
                 && response.Warnings.General[0]
                 && response.Warnings.General[0].ErrorCode);
}
